<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { getIp, logout } from '@/apis/index.js'

export default {
  name: 'App',
  created() {
    this.getIpAdd()
  },
  methods: {
    async getIpAdd() {
      try {
        let res = await getIp()
        this.$store.commit('getIP', res.data)
      } catch (e) {
        console.log('e :>> ', e)
      }
    },
  }
}
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
